import { storage } from "../../storage/port";
/**
 * Cold-start entitlement mirror in localStorage.
 *
 * Exists so a returning user doesn't see a flash of locked UI in the window
 * between page load and the first `users/profile` response. It is a cache of
 * what the previous session saw, never a source of truth — anything
 * security-relevant is enforced by the backend.
 *
 * This is the only module allowed to touch these keys. Nothing here reads or
 * writes credits: a stale balance would be worse than no balance, so
 * `GET /credits` is always fetched fresh.
 */
const PAID = "paid";
const SUBSCRIPTION = "subscription";
const HAS_IMPORTED_CLUB = "hasImportedClub";
const SUBSCRIPTION_INTERVAL = "subscriptionInterval";
/*
  Written by builds before the credits model. Nothing reads it any more — it was
  always derivable from the cached subscription, since both were written from
  the same gold/diamond check. Still cleared on logout so it doesn't linger.
*/
const LEGACY_CAN_USE_CLUB_IMPORT = "canUseClubImport";
export const readCachedEntitlement = () => ({
    paid: storage.get(PAID) === "true",
    subscription: storage.get(SUBSCRIPTION) || undefined,
    hasImportedClub: storage.get(HAS_IMPORTED_CLUB) === "true",
});
export const cacheEntitlement = ({ paid, subscription, hasImportedClub, subscriptionInterval, }) => {
    storage.set(PAID, JSON.stringify(paid));
    storage.set(SUBSCRIPTION, subscription);
    storage.set(HAS_IMPORTED_CLUB, JSON.stringify(hasImportedClub));
    if (subscriptionInterval) {
        storage.set(SUBSCRIPTION_INTERVAL, subscriptionInterval);
    }
};
/**
 * Narrow writer for the moment a first import completes, so the next page load
 * doesn't fall back to a loading state for a user who has just imported.
 */
export const setCachedImportedClub = (hasImportedClub) => storage.set(HAS_IMPORTED_CLUB, JSON.stringify(hasImportedClub));
export const clearCachedEntitlement = () => {
    storage.remove(PAID);
    storage.remove(SUBSCRIPTION);
    storage.remove(HAS_IMPORTED_CLUB);
    storage.remove(SUBSCRIPTION_INTERVAL);
    storage.remove(LEGACY_CAN_USE_CLUB_IMPORT);
};
//# sourceMappingURL=coldStart.js.map